import React, { useState } from "react";
import Modal from "./Modal";
import axios from "../../axios/AxiosInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const AddCommentModal = ({
  isOpen,
  onClose,
  candidate,
  candidates,
  setCandidates,
  setComments,
}) => {
  const [formData, setFormData] = useState({
    comment: "",
    type: "interne",
    commentator: localStorage.getItem("name"),
  });
  const navigate = useNavigate();

  const updateCandidate = () => {
    axios
      .post(`tempworker-candidate/${candidate._id}/update-comment`, {
        comments: [
          { ...formData, createdAt: Date.now() },
          ...candidate.comments,
        ],
      })
      .then((res) => {
        toast.success("Commentaire ajouté ! ");
        const candidateIdx = candidates.findIndex(
          (cdte) => cdte._id === candidate._id,
        );
        const newCandidates = [...candidates];
        newCandidates[candidateIdx] = {
          ...candidate,
          comments: [
            { ...formData, createdAt: Date.now() },
            ...candidate.comments,
          ],
        };
        setComments([
          { ...formData, createdAt: Date.now() },
          ...candidate.comments,
        ]);
        setCandidates(newCandidates);
        onClose();
      })
      .catch((e) => {
        if (e.response.data.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateCandidate();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Ajouter un commentaire"
      className="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="type"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Type de commentaire
          </label>
          <select
            id="type"
            name="type"
            required
            value={formData.type}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="interne">Interne</option>
            <option value="client">Visible par le client</option>
            <option value="candidat">Visible par le candidat</option>
          </select>
        </div>

        <div>
          <label
            htmlFor="comment"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Commentaire
          </label>
          <textarea
            id="comment"
            name="comment"
            rows={5}
            required
            value={formData.comment}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Saisissez votre commentaire ici..."
          />
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </Modal>
  );
};
